import createActions from '../utils/createActions';
import * as constants from './constants';

const exp = {...createActions(constants)};

export default exp;



// WEBPACK FOOTER //
// ./src/User/actions.js